import { useState } from "react";
import PropTypes from "prop-types";

const TabelaDePrecoBotoes = ({ handleDeletar, handleRenovar }) => {
  const [showDeleteButton] = useState(typeof handleDeletar == "function");
  const [showRenewButton] = useState(typeof handleRenovar == "function");
  return (
    <div className="flex gap-2 flex-col sm:flex-row">
      {showDeleteButton && (
        <button onClick={handleDeletar} className="button bg-[red] text-white">
          Deletar
        </button>
      )}
      {showRenewButton && (
        <button
          onClick={handleRenovar}
          className="button bg-[#0DB14B] text-white"
          data-test-id="button-renovar"
        >
          Renovar
        </button>
      )}
    </div>
  );
};

TabelaDePrecoBotoes.propTypes = {
  handleDeletar: PropTypes.func,
  handleRenovar: PropTypes.func,
};

export default TabelaDePrecoBotoes;
